/*
 * Copyright (c) 2024 Ask Sage, Inc. All rights reserved.
 * This software is the confidential and proprietary information of Ask Sage, Inc.
 * You shall not disclose such confidential information and shall use it only in
 * accordance with the terms of the license agreement you entered into with Ask Sage, Inc.
 * THIS SOFTWARE IS PROVIDED "AS IS" AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 * INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 * FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL ASK SAGE, INC.
 * OR ITS CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 * EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT
 * OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT,
 * STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
 * OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 * You may not use this software except in compliance with the License.
 * You may not modify, reverse engineer, or redistribute this software.
 */
var LOCAL = false;

if(LOCAL === true && process.env.NODE_ENV !== 'development') {
  LOCAL = false;
}

if(window.RUNTIME_VARS === undefined) {
  window.RUNTIME_VARS = {}
}

var chat_server_host = window.RUNTIME_VARS.REACT_APP_asksage_chat_service || 'https://api.asksage.ai/server';
var user_server_host = window.RUNTIME_VARS.REACT_APP_asksage_user_service || 'https://user-server-cac-gov.asksage.ai';
var prompt_server_host = window.RUNTIME_VARS.REACT_APP_asksage_prompt_service || 'https://api.asksage.ai/prompt';

// Overriding banner
var banner_override = window.RUNTIME_VARS.REACT_APP_banner_override || null
if(banner_override == '') {
  banner_override = null
}

var classification_level = window.RUNTIME_VARS.REACT_APP_classification_level || 'cui'
if(classification_level == '') {
  classification_level = 'cui'
}

// Overriding branding
var cobranding_name = window.RUNTIME_VARS.REACT_APP_cobranding_name || null
if(cobranding_name == '') {
  cobranding_name = null
}

// Overriding branding
var cobranding_logo = window.RUNTIME_VARS.REACT_APP_cobranding_logo || null
if(cobranding_logo == '') {
  cobranding_logo = null
}

var allowed_models = window.RUNTIME_VARS.REACT_APP_allowed_models || null
if(allowed_models == '') {
  allowed_models = null
}
if(allowed_models == null) {
  allowed_models = ['gpt', 'gpt-4o', 'gpt-4o-mini', 'gpt-o1', 'gpt-o3-mini', 'gpt-4.5-preview', 'gpt-gov', 'gpt4-gov', 'gpt-4o-gov', 'gpt-4o-mini-gov', 'gpt-4.1', 'gpt-4.1-mini', 'gpt-4.1-nano', 'gpt-o3', 'gpt-o4-mini', 'gpt-image-1', 'dall-e-3', 'claude-35-sonnet', 'claude-37-sonnet', 'claude-4-sonnet', 'claude-4-opus','google-gemini-20-flash', 'google-gemini-2.5-pro', 'aws-bedrock-claude-35-sonnet-gov', 'groq-70b', 'groq-llama33', 'groq-llama4-scout', 'xai-grok', 'google-imagen-3']
}
else {
  allowed_models = allowed_models.split(',')
}

var allowed_classifications = window.RUNTIME_VARS.REACT_APP_allowed_classifications || null
if(allowed_classifications == '') {
  allowed_classifications = null
}
if(allowed_classifications == null) {
  allowed_classifications = ['Unclassified', 'CUI']
}
else {
  if(allowed_classifications.indexOf(',') !== -1) {
    allowed_classifications = allowed_classifications.split(',')
  }
  else {
    allowed_classifications = [allowed_classifications]
  }
}

var force_register_organizations = window.RUNTIME_VARS.REACT_APP_force_register_organizations || null

if(force_register_organizations == '' || force_register_organizations == null || force_register_organizations == undefined) {
  force_register_organizations = null
}
if(force_register_organizations !== null) {
  if(force_register_organizations.indexOf(',') !== -1) {
    force_register_organizations = force_register_organizations.split(',')
  }
  else {
    force_register_organizations = [force_register_organizations]
  }
  if(force_register_organizations[0] !== 'Select an organization') {
    force_register_organizations.unshift('Select an organization')
  }
}

var allowed_countries = window.RUNTIME_VARS.REACT_APP_allowed_countries || null
if(allowed_countries == '') {
  allowed_countries = null
}
if(allowed_countries == null) {
  allowed_countries = ['Select a country',
    'United States',
    'United Kingdom',
    'Canada',
    'Australia',
    'New Zealand',
    'Belgium',
    'Bulgaria',
    'Czech Republic',
    'Denmark',
    'Germany',
    'Estonia',
    'Ireland',
    'India',
    'Greece',
    'Spain',
    'Singapore',
    'Japan',
    'France',
    'Croatia',
    'Italy',
    'Cyprus',
    'Latvia',
    'Lithuania',
    'Luxembourg',
    'Hungary',
    'Malta',
    'Netherlands',
    'Austria',
    'Poland',
    'Portugal',
    'Romania',
    'Slovenia',
    'Slovakia',
    'Saudi Arabia',
    'Sweden',
    'Finland',
    'Iceland',
    'Norway',
    'Liechtenstein',
    'Switzerland']
}
else {
  allowed_countries = allowed_countries.split(',')
}

var box_prefix_url = window.RUNTIME_VARS.REACT_APP_box_prefix_url || "box"
if(box_prefix_url == '' || box_prefix_url == null || box_prefix_url == undefined) {
  box_prefix_url = "box"
}


var customer_tenant = window.RUNTIME_VARS.REACT_APP_customer_tenant || false
if(customer_tenant == '') {
  customer_tenant = false
}
if(customer_tenant === 'true') {
  customer_tenant = true
}

var force_chat_redirect = window.RUNTIME_VARS.REACT_APP_force_chat_redirect || false
if(force_chat_redirect == '') {
  force_chat_redirect = false
}
if(force_chat_redirect === 'true' || force_chat_redirect === true) {
  force_chat_redirect = true
}
else {
  force_chat_redirect = false
}

var block_live = window.RUNTIME_VARS.REACT_APP_block_live || false
if(block_live == '') {
  block_live = false
}
if(block_live === 'true') {
  block_live = true
}
else {
  block_live = false
}

var block_deep_agent = window.RUNTIME_VARS.REACT_APP_block_deep_agent || false
if(block_deep_agent == '') {
  block_deep_agent = false
}
if(block_deep_agent === 'true') {
  block_deep_agent = true
}
else {
  block_deep_agent = false
}

var hide_login = window.RUNTIME_VARS.REACT_APP_hide_login || false
if(hide_login == '') {
  hide_login = false
}
if(hide_login === 'true') {
  hide_login = true
}
else {
  hide_login = false
}

var enable_text_to_speech = window.RUNTIME_VARS.REACT_APP_enable_text_to_speech || false
if(enable_text_to_speech == '') {
  enable_text_to_speech = false
}
if(enable_text_to_speech === 'true') {
  enable_text_to_speech = true
}
else {
  enable_text_to_speech = false
}

var email_disabled = window.RUNTIME_VARS.REACT_APP_email_disabled || false
if(email_disabled == '') {
  email_disabled = false
}
if(email_disabled === 'true') {
  email_disabled = true
}
else {
  email_disabled = false
}

var block_discord = window.RUNTIME_VARS.REACT_APP_block_discord || false
if(block_discord == '') {
  block_discord = false
}
if(block_discord === 'true') {
  block_discord = true
}

var block_gpt_auto = window.RUNTIME_VARS.REACT_APP_block_gpt_auto || false
if(block_gpt_auto == '') {
  block_gpt_auto = false
}
if(block_gpt_auto === 'true') {
  block_gpt_auto = true
}

if(block_gpt_auto !== true) {
  allowed_models.unshift('auto');
}

var voicerecorder_enabled = window.RUNTIME_VARS.REACT_APP_voicerecorder_enabled || false
if(voicerecorder_enabled == '') {
  voicerecorder_enabled = true
}
if(voicerecorder_enabled === 'true') {
  voicerecorder_enabled = true
}

var saml_enabled = window.RUNTIME_VARS.REACT_APP_saml_enabled || false
if(saml_enabled == '') {
  saml_enabled = false
}
if(saml_enabled === 'true') {
  saml_enabled = true
}

var hide_cac = window.RUNTIME_VARS.REACT_APP_hide_cac || false
if(hide_cac == '') {
  hide_cac = false
}
if(hide_cac === 'true') {
  hide_cac = true
}
else {
  hide_cac = false
}

var hide_cui_chip = window.RUNTIME_VARS.REACT_APP_hide_cui_chip || false
if(hide_cui_chip == '') {
  hide_cui_chip = false
}
if(hide_cui_chip === 'true') {
  hide_cui_chip = true
}
else {
  hide_cui_chip = false
}

var show_webauthn = window.RUNTIME_VARS.REACT_APP_show_webauthn || false
if(show_webauthn == '') {
  show_webauthn = false
}
if(show_webauthn === 'true') {
  show_webauthn = true
}
else {
  show_webauthn = false
}

var force_tenant_domain = window.RUNTIME_VARS.REACT_APP_force_tenant_domain || null
if(force_tenant_domain == '' || force_tenant_domain == null || force_tenant_domain == undefined || force_tenant_domain.length < 1) {
  force_tenant_domain = null
}

var file_allowed_txt = `<strong>Drag and drop files here or click to browse.</strong><br /><br /><strong>Supported File Formats:</strong><br /><div style="text-align: left"><strong>Documents</strong>: zip, pdf, xlsx, pptx, docx, ppt, csv, cc, sql, cs, hh, c, php, js, py, html, xml, msg, odt, epub, eml, rtf, txt, doc, json, md, tsv, yaml, yml, java, rb, sh, bat, ps1, xsd, wsdl, scala, sbt, go, h, cpp, ipynb, dockerfile, ts, tsx, hpp, rs (50MB max)<br /><strong>Images</strong>: jpeg, jpg, png (50MB max)<br /><strong>Audio</strong>: mp3, mp4, mpeg, mpga, m4a, wav, webm (500MB max)<br />15 files per upload maximum.</div>`

var terms_text_default = "By using this service, you unilaterally agree to following the terms and conditions<br /><br />TERMS AND CONDITIONS OF USE FOR \"ASK SAGE\" <br /><br />1.	Introduction<br />These terms and conditions (the \"Terms\") govern your use of the Ask Sage chat assistant (the \"Service\") provided by Ask Sage, Inc. (hereinafter referred to as \"we,\" \"us,\" or \"our\"). By accessing or using the Service, you agree to be bound by these Terms. If you do not agree to these Terms, you may not access or use the Service. In addition, when using the Service, you are subject to the terms and conditions of any third-party product or service integrated into Ask Sage. These include, but are not limited to, Google PaLM 2 (https://developers.generativeai.google/terms), Anthropic, the Azure OpenAI Service, which is subject to the applicable Azure Legal Terms (including relevant Product Terms), and the Supplemental Preview Terms for Azure OpenAI Service; the OpenAI, LLC Terms of Use (available at: https://openai.com/terms/), including their Service Terms, Sharing & Publication Policy, and Usage Policies; and the Cohere Inc. Terms of Service; as well as, any other documentation, guidelines, or policies  from any party may provide in writing that governs the use of their services by third-party applications such as Ask Sage, Inc. PLEASE READ THESE TERMS OF SERVICE CAREFULLY, AS THEY GOVERN YOUR USE OF THE SERVICE.<br /><br />1.2	Modifications to Terms<br />We reserve the right, at our sole discretion, to change or modify any portion, in whole or in part, of these Terms at any time. If we do this, depending on the nature of the change, we will notify you, either through the Service's user interface, in an email notification or through other reasonable means and as required by applicable law. Your continued use of the Service after the date any such changes become effective constitutes your acceptance of the new Terms.<br /><br />1.3	Privacy<br />At Ask Sage, we respect the privacy of our users. By using the Service, you consent to our collection and use of personal data including email, first name, last name, organization, country and phone. For government users, we collect your CAC information for authentication purposes.<br /><br />2.	Access and Use of the Service<br />2.1	Service Description<br />Ask Sage is an artificial intelligence-powered Generative AI platform that provides users with information and assistance for informational and general purposes only. We do not guarantee the accuracy or completeness of the information provided by Ask Sage and will not be held liable for any errors or omissions from use of this information. Registration with Ask Sage grants you a limited, non-exclusive, non-transferable, license to access the Service. Except for the foregoing limited license, no right, title or interest shall be transferred to you. You agree not to use the service for public performances. Ask Sage may revoke your access at any time at its sole discretion.<br /><br />2.2	\"As-is\" Service<br />Ask Sage is currently offered “as-is”. Ask Sage makes no representations or warranties for the Service, including any warranty that the Service will be generally available, uninterrupted or error-free, or that Content will not be lost or damaged. Except to the extent prohibited by law, Ask Sage expressly disclaims all warranties for the Service, including any implied warranties of merchantability, satisfactory quality, fitness for a particular purpose, non-infringement, and any warranties arising out of any course of dealing or usage of trade.<br /><br />2.3	Registration Obligation <br />You shall be required to register with Ask Sage in order to access and use the Service. If you choose to register for the Service, you agree to provide and maintain true, accurate, current and complete information about yourself as prompted by the Service's registration form. You are limited to one account per person. If you are under 18 years of age, you are not authorized to use the Service, with or without registering. If the subscriber is not an individual but a corporate entity, you warrant that you are duly authorized as an agent of a legally registered entity to enter into and bind that entity to these Terms.<br /><br />2.4	Account, Password and Security<br />You may never use another's account, and you may not provide another person with the username and password to access your account. You should maintain control over all of the devices that are used to access the Service. If you fail to maintain control of a device, other users may access the Service through your account. You are fully responsible for any and all activities that occur under your account, and it is your responsibility to ensure that your password remains confidential and secure. You agree to (a) immediately notify Ask Sage of any unauthorized use of your password or account or any other breach of security, and (b) ensure that you exit from your account at the end of each session when accessing the Service. Ask Sage will not be liable for any loss or damage arising from your failure to comply with this Section.<br /><br />2.5	Modifications to Service<br />Ask Sage operates at the discretion of third-parties, such as Google PaLM 2, Azure OpenAI and Cohere, and will not be liable for any service changes, including modifications or loss in service, resulting from actions taken by any party or service integrated into Ask Sage. Ask Sage reserves the right to modify or discontinue, temporarily or permanently, the Service (or any part thereof) with or without notice. You agree Ask Sage will not be liable to you or to any third party for any modification, suspension or discontinuance of the Service. We have no obligation to retain any of Your Account Content for any period of time beyond what may be required by applicable law. In the event any third party service implements a modification, suspension or discontinuance of the services, Ask Sage may immediately terminate any license and access to the Ask Sage Service, without notice. Ask Sage will have thirty (30) days to remediate and/or replace the third-party service. Notwithstanding the aforementioned, Ask Sage shall have no obligation to restore Service, in whole or part.<br /><br />3.	Conditions of Use<br />3.1.	Prohibited Uses<br />You may not use the Service for any illegal or unauthorized purpose, or to exfiltrate data, steal the intellectual property, or technology of Ask Sage or any third party. Additionally, you may not use the Service for any activity that violates the OpenAI LLC Terms of Service or other related policies of any third-party integrated into Ask Sage.<br />In this context, Data exfiltration occurs when malware and/or a malicious actor carries out an unauthorized data transfer. Data exfiltration is also considered a form of data theft. This doesn't include normal use of the Service. All data entered by the User, all Prompts entered by the User and results created by the User on the Service are owned by the User.<br /><br />3.2	Ask Sage will be wrong<br />The information/answers provided by the Service will be wrong due Large Language Models (LLMs) being wrong. Use provided information at your own risk and verify the information or code before making assumption or using it. Use it at your own risk.<br /><br />3.3 	Similarity of Content<br />Due to the nature of machine learning, Output may not be unique across users and the Service may generate the same or similar output.<br /><br />3.4 Plugins, Database Connections and Use of Credentials<br /><br />By using our database connection feature, you represent and warrant that:<br />1. You have legally obtained the credentials you are using;<br />2. You have the necessary rights, permissions, and authorizations to use these credentials and to access and use the associated database/data lake;<br />3. You will not use our database connection feature to conduct any illegal activities, including but not limited to unauthorized access to databases, denial of service (DDoS) attacks, or any form of hacking or cybercrime.<br /><br />You agree to indemnify, defend, and hold harmless Ask Sage, Inc., its affiliates, and their respective directors, officers, employees, and agents from and against any and all claims, liabilities, damages, losses, costs, expenses, or fees (including reasonable attorneys' fees) that arise from or relate to your violation of this section of the terms and conditions.<br /><br />You understand and agree that Ask Sage, Inc. is not responsible for any damage, loss, or harm resulting from your use of the database connection feature, including but not limited to damage to the database, loss of data, or any other adverse effects.<br /><br />4.	Restrictions and Fees<br />4.1	Token Limitation<br />Free trial accounts are limited to two hundred thousand (200,000) tokens per user, per month, for 1 month. Access beyond this limit is available for a fee by subscribing via credit card or by contacting sales@asksage.ai with various monthly and yearly plans.<br /><br />4.2	Fees and Pricing<br />Ask Sage, at its sole discretion, reserves the right to set, modify or otherwise establish one-time or recurring fees for access to the Service, in whole or in part. Current or past use of the Service does not entitle you to an exception or reduction in any future fees.<br /><br />Tokens reset the 1st of each month and do not rollover month to month.<br /><br />5.	Intellectual Property <br />5.1	Trademarks<br />The Ask Sage name and logos are trademarks and service marks of Ask Sage (collectively the “Ask Sage Trademarks”). Other product, and service names and logos used and displayed via the Service may be trademarks or service marks of their respective owners who may or may not endorse or be affiliated with or connected to Ask Sage. Nothing in these Terms or the Service should be construed as granting, by implication, estoppel, or otherwise, any license or right to use any of the Ask Sage Trademarks displayed on the Service, without our prior written permission in each instance. All goodwill generated from the use of Ask Sage Trademarks will inure to our exclusive benefit. You agree that you will not purchase search engine or other pay per click keywords (such as Google Ads), or domain names that use Ask Sage or Ask Sage trademarks and/or variations and misspellings thereof.<br /><br />5.2	Codex and Code Generation<br />Output generated by code generation features of the Service, including OpenAI Codex, may be subject to third party licenses, including, without limitation, open source licenses.<br /><br />6. 	Disclaimers and Liability	<br />6.1	Disclaimer of Warranties<br />The Service is provided \"as is\" and \"as available\" without any representations or warranties of any kind, express or implied, including but not limited to, implied warranties of merchantability and fitness for a particular purpose. We do not warrant that the Service will be uninterrupted or error-free, and we will not be liable for any interruptions or errors.<br /><br />6.2	Limitation of Liability<br />YOU EXPRESSLY UNDERSTAND AND AGREE THAT ASK SAGE WILL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, EXEMPLARY DAMAGES, OR DAMAGES FOR LOSS OF PROFITS INCLUDING BUT NOT LIMITED TO, DAMAGES FOR LOSS OF GOODWILL, USE, DATA OR OTHER INTANGIBLE LOSSES (EVEN IF ASK SAGE HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES), WHETHER BASED ON CONTRACT, TORT, NEGLIGENCE, STRICT LIABILITY OR OTHERWISE, RESULTING FROM: (I) THE USE OR THE INABILITY TO USE THE SERVICE; (II) THE COST OF PROCUREMENT OF SUBSTITUTE GOODS AND SERVICES RESULTING FROM ANY GOODS, DATA, INFORMATION OR SERVICES PURCHASED OR OBTAINED OR MESSAGES RECEIVED OR TRANSACTIONS ENTERED INTO THROUGH OR FROM THE SERVICE; (III) UNAUTHORIZED ACCESS TO OR ALTERATION OF YOUR TRANSMISSIONS OR DATA; (IV) STATEMENTS OR CONDUCT OF ANY THIRD PARTY ON THE SERVICE; OR (V) ANY OTHER MATTER RELATING TO THE SERVICE. IN NO EVENT WILL ASK SAGE'S TOTAL LIABILITY TO YOU FOR ALL DAMAGES, LOSSES OR CAUSES OF ACTION EXCEED THE AMOUNT YOU HAVE PAID ASK SAGE IN THE LAST MONTH, OR, IF GREATER, ONE DOLLAR ($1). SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF CERTAIN WARRANTIES OR THE LIMITATION OR EXCLUSION OF LIABILITY FOR INCIDENTAL OR CONSEQUENTIAL DAMAGES. ACCORDINGLY, SOME OF THE ABOVE LIMITATIONS SET FORTH ABOVE MAY NOT APPLY TO YOU. IF YOU ARE DISSATISFIED WITH ANY PORTION OF THE SERVICE OR WITH THESE TERMS OF SERVICE, YOUR SOLE AND EXCLUSIVE REMEDY IS TO DISCONTINUE USE OF THE SERVICE.<br /><br />6.3	Indemnity<br />To the fullest extent permitted by law, you agree to release, indemnify and hold Ask Sage and its affiliates and their officers, employees, directors and agent harmless from any and all losses, damages, expenses, including reasonable attorneys' fees, rights, claims, actions of any kind and injury (including death) arising out of or relating to your use of the Service, any Content, your connection to the Service, your violation of these Terms or your violation of any rights of another. If you are a California resident, you waive California Civil Code Section 1542, which says: \"A general release does not extend to claims which the creditor does not know or suspect to exist in his favor at the time of executing the release, which if known by him must have materially affected his settlement with the debtor.\" If you are a resident of another jurisdiction, you waive any comparable statute or doctrine.<br /><br />6.4	Technical Content and Output<br />Ask Sage does not provide specific direction or assessment on any technical, professional or licensed field. You acknowledge and agree that the Service is not intended to be, and will not be used as, a substitute for consultation and assessment by a licensed, experienced professional. You agree to consult system authorities and primary sources before initiating any practices or changes. You also acknowledge and agree to accept the inherent risks and dangers in participating in new procedures and practices. You agree that Ask Sage will not be liable for any loss, or damages arising from your access or practice of the Service's content.<br /><br />6.5 Grant of Rights<br />By using this product, you grant Ask Sage, Inc. the right to use your logo on our website and marketing materials for the purpose of promoting the Ask Sage Service. You represent and warrant that you have the necessary rights and permissions to grant this license.<br /><br />6.6	Governing Law<br />These Terms shall be governed by and construed in accordance with the laws of Commonwealth of Virginia, United States, without giving effect to any principles of conflicts of law.<br /><br />6.7 	Binding Arbitration; Class Action Waiver<br />You and Ask Sage agree to resolve any claims relating to these Terms or the Services through final and binding arbitration. You have the right to opt out of these arbitration terms, and future changes to these arbitration terms, by emailing info@asksage.ai within 30 days of agreeing to these arbitration terms or the relevant changes. YOU AND ASK SAGE AGREE THAT EACH MAY BRING CLAIMS AGAINST THE OTHER ONLY IN YOUR OR ITS INDIVIDUAL CAPACITY, AND NOT AS A PLAINTIFF OR CLASS MEMBER IN ANY PURPORTED CLASS OR REPRESENTATIVE PROCEEDING. Disputes must be brought on an individual basis only, and may not be brought as a plaintiff or class member in any purported class, consolidated, or representative proceeding. Class arbitrations, class actions, private attorney general actions, and consolidation with other arbitrations are not allowed. If for any reason a dispute proceeds in court rather than through arbitration, each party knowingly and irrevocably waives any right to trial by jury in any action, proceeding, or counterclaim. This does not prevent either party from participating in a class-wide settlement of claims.<br /><br />Contact Us<br />If you have any questions or concerns about these Terms, please contact us at info@asksage.ai.<br /><br />By using Ask Sage, you acknowledge that you have read and understood these Terms and agree to be bound by them.<br /><br />These terms are written by a lawyer and is considered as a proper legal document.<br /><br />"

var terms_text = window.RUNTIME_VARS.REACT_APP_terms_text || terms_text_default
if(terms_text == '' || terms_text == null || terms_text == undefined) {
  terms_text = terms_text_default
}

var custom_docs_url_default = "https://docs.asksage.ai"
var custom_docs_url = window.RUNTIME_VARS.REACT_APP_custom_docs_url || custom_docs_url_default
if(custom_docs_url == '' || custom_docs_url == null || custom_docs_url == undefined) {
  custom_docs_url = custom_docs_url_default
}

var subscribe_banner_text_default = "30-Day Free Trial: Subscribe Now!"

var subscribe_banner_text = window.RUNTIME_VARS.REACT_APP_subscribe_banner_text || subscribe_banner_text_default
if(subscribe_banner_text == '' || subscribe_banner_text == null || subscribe_banner_text == undefined) {
  subscribe_banner_text = subscribe_banner_text_default
}

const domainName = window.location.hostname;

// Function to get the latter part of the domain
function getLatterPartOfDomain(hostname, cur_tenant_domain=null) {
  try {
    if(cur_tenant_domain !== null) {
      return cur_tenant_domain;
    }

    // Split the hostname into parts
    let parts = hostname.split('.');
    
    // Check if the hostname has at least three parts
    if (parts.length >= 3) {
        // Remove the first part of the hostname
        parts.shift();
    }
    
    // Join the remaining parts of the hostname
    let latterPart = parts.join('.');
    
    // Return the latter part of the domain
    return latterPart;
  }
  catch { return hostname; }
}

var tenant = "Ask Sage";
var tenantDomain = getLatterPartOfDomain(domainName, force_tenant_domain);
if(tenantDomain === 'localhost') {
  tenantDomain = 'dev.asksage.ai';
}

if (tenantDomain === "dod.asksage.ai" || tenantDomain === "capra.asksage.ai") {
  tenant = "AskSageDoD";
}
else if (tenantDomain === "civ.asksage.ai") {
  tenant = "AskSageCIV";
}
else if (tenantDomain !== "asksage.ai") {
  tenant = "AskSageCustom";
}

var user_server_host_no_cac = 'https://api.' + tenantDomain + '/user';
if (domainName.includes('chat-nocac')) {
  user_server_host = user_server_host_no_cac;
}
var user_server_host_force_default = window.RUNTIME_VARS.REACT_APP_host_force_default || false
if(user_server_host_force_default === 'true' || user_server_host_force_default === true) {
  user_server_host_no_cac = user_server_host;
}

var has_google_login_enabled = window.RUNTIME_VARS.REACT_APP_has_google_login_enabled || false
if(has_google_login_enabled == '') {
  has_google_login_enabled = true
}
if(has_google_login_enabled === 'true') {
  has_google_login_enabled = true
}

var has_warning_use_mil = window.RUNTIME_VARS.REACT_APP_has_warning_use_mil || false
if(has_warning_use_mil === 'true' || has_warning_use_mil === true) {
  has_warning_use_mil = true
}
else {
  has_warning_use_mil = false
}

var has_government_banner = window.RUNTIME_VARS.REACT_APP_has_government_banner || false
if(has_government_banner == '') {
  has_government_banner = false
}
if(has_government_banner === 'true') {
  has_government_banner = true
}

var max_files_attachment = window.RUNTIME_VARS.REACT_APP_max_files_attachment || 5
if(max_files_attachment == '') {
  max_files_attachment = 5
}
if(typeof max_files_attachment === 'string') {
  max_files_attachment = parseInt(max_files_attachment, 10)
}

var disable_youtube = window.RUNTIME_VARS.REACT_APP_disable_youtube || false
if(disable_youtube == '') {
  disable_youtube = false
}
if(disable_youtube === 'true') {
  disable_youtube = true
}

var chat_service_url_files = chat_server_host;

if (LOCAL === true) {
  chat_server_host = 'http://localhost:5000';
  //chat_server_host = 'https://api.dev.asksage.ai/server';
  has_google_login_enabled = true;
  chat_service_url_files = chat_server_host
  chat_service_url_files = 'https://api.asksage.ai/server';
  //user_server_host = 'http://localhost:5001';
  //user_server_host_no_cac = user_server_host;
  user_server_host = 'https://user-server-nginx.asksage.ai';
  user_server_host_no_cac = 'https://api.asksage.ai/user';
  prompt_server_host = 'https://api.asksage.ai/prompt';
  //prompt_server_host = 'http://localhost:5003';

  show_webauthn = true;

  voicerecorder_enabled = true;
}

var support_email = window.RUNTIME_VARS.REACT_APP_support_email || 'support@asksage.ai'
if(support_email == '' || support_email === null || support_email === undefined) {
  support_email = 'support@asksage.ai'
}

var copyright_year = '2025';

var token_ratio_modifier = window.RUNTIME_VARS.REACT_APP_token_ratio_modifier || 0.7;
if(token_ratio_modifier == '') {
  token_ratio_modifier = 0.7;
}
if(typeof token_ratio_modifier === 'string') {
  token_ratio_modifier = parseFloat(token_ratio_modifier);
}
if(isNaN(token_ratio_modifier)) {
  token_ratio_modifier = 0.7;
}

export const default_chat_service_url = chat_server_host;
export const default_chat_service_url_files = chat_service_url_files;
export const default_user_service_url = user_server_host;
export const default_user_service_url_no_cac = user_server_host_no_cac;
export const default_prompt_service_url = prompt_server_host;
export const default_banner_override = banner_override;
export const default_customer_tenant = customer_tenant;
export const default_block_live = block_live;
export const default_tenant = tenant;
export const default_tenantDomain = tenantDomain;
export const default_hide_cac = hide_cac;
export const default_allowed_models = allowed_models;
export const default_saml_enabled = saml_enabled;
export const default_voicerecorder_enabled = voicerecorder_enabled;
export const default_has_google_login_enabled = has_google_login_enabled;
export const default_copywrite_year = copyright_year;
export const default_disable_youtube = disable_youtube;
export const default_block_gpt_auto = block_gpt_auto;
export const default_box_prefix_url = box_prefix_url;
export const default_block_discord = block_discord;
export const default_has_government_banner = has_government_banner;
export const default_terms_text = terms_text;
export const default_allowed_countries = allowed_countries;
export const default_email_disabled = email_disabled;
export const default_enable_text_to_speech = enable_text_to_speech;
export const default_hide_login = hide_login;
export const default_force_chat_redirect = force_chat_redirect;
export const default_file_allowed_txt = file_allowed_txt;
export const default_show_webauthn = show_webauthn;
export const default_support_email = support_email;
export const default_cobranding_name = cobranding_name;
export const default_hide_cui_chip = hide_cui_chip;
export const default_classification_level = classification_level;
export const default_allowed_classifications = allowed_classifications;
export const default_has_warning_use_mil = has_warning_use_mil;
export const default_token_ratio_modifier = token_ratio_modifier;
export const default_max_files_attachment = max_files_attachment;
export const default_force_register_organizations = force_register_organizations;
export const default_subscribe_banner_text = subscribe_banner_text;
export const default_block_deep_agent = block_deep_agent;
export const default_cobranding_logo = cobranding_logo;
export const default_custom_docs_url = custom_docs_url;